import { useTranslation } from "react-i18next";
import React, { useState } from "react";

type TaxNumberInputProps = {
  taxNumber: string;
  setTaxNumber: React.Dispatch<React.SetStateAction<string>>;
  taxRequiredErrorMessage: string | null;
  setTaxNumberRequiredErrorMessage: React.Dispatch<
    React.SetStateAction<string | null>
  >;
  disabled?: boolean;
};

const maxLength = 15;

function TaxNumberInput({
  taxNumber,
  setTaxNumber,
  taxRequiredErrorMessage,
  setTaxNumberRequiredErrorMessage,
  disabled = false,
}: TaxNumberInputProps) {
  const { t } = useTranslation();
  const [showError, setShowError] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    let filteredValue = inputValue.replace(/[^0-9-]/g, "");

    if (filteredValue.startsWith("-")) {
      filteredValue = filteredValue.slice(1);
    }
    if (filteredValue.charAt(maxLength - 1) === "-") {
      filteredValue = filteredValue.slice(0, -1);
    }

    // set required message false if the input not empty
    if (filteredValue.length > 0) {
      setTaxNumberRequiredErrorMessage(null);
    }else{
      setTaxNumberRequiredErrorMessage(t("taxNumberInput.required") as string);
    }


    filteredValue = filteredValue.replace(/--+/g, "-");

    if (filteredValue.length > maxLength) {
      setShowError(true);
      return;
    }

    setTaxNumber(filteredValue);
    setShowError(false);
  };

  const handleBlur = () => {
    setShowError(false);
  };

  return (
    <div className="flex w-full flex-col gap-1">
      <label htmlFor="taxNumber" className="block font-semibold">
    {  t("taxNumberInput.label")}
      </label>
      <input
        type="text"
        id="taxNumber"
        value={taxNumber}
        onChange={handleInputChange}
        onBlur={handleBlur}
        disabled={disabled}
        className="mt-1 block h-12 w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-border focus:outline-none disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
        placeholder={t("taxNumberInput.label") as string}
      />
      {showError && (
        <span className="text-sm text-red-500">
          {t("taxNumberInput.maxLength")}
        </span>
      )}
      {taxRequiredErrorMessage && (
        <span className="text-sm text-red-500">{taxRequiredErrorMessage}</span>
      )}
    </div>
  );
}

export default TaxNumberInput;
